import { render, staticRenderFns } from "./MyWork.vue?vue&type=template&id=7a6f4630&scoped=true&"
import script from "./MyWork.vue?vue&type=script&lang=js&"
export * from "./MyWork.vue?vue&type=script&lang=js&"
import style0 from "./MyWork.vue?vue&type=style&index=0&id=7a6f4630&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f4630",
  null
  
)

export default component.exports